import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";

import { AjaxResult } from "../../../../../enums/ajaxResult";
import { useApi } from "../../../../useApi";

export function useDeleteLease(boxId: number) {
    const { boxApi } = useApi();
    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);

    const deleteLease = useCallback((onSuccess: () => void) => {
        setLoading(true);
        boxApi.deleteCurrentLease(boxId).then((r) => {
            if (r.result === AjaxResult.Success) {
                enqueueSnackbar("Lease was deleted!", { variant: "success" });
                onSuccess();
            } else {
                enqueueSnackbar("Failed to delete lease", { variant: "error" });
            }
            setLoading(false);
        });
    }, [boxApi, boxId, enqueueSnackbar]);

    return { deleteLease, loading };
}
